import React from "react";
import { openExternalUrl } from "../../../external_link";

const ExternalLink = (props: JSX.IntrinsicElements["a"] & { href: string }) => {
  const handleClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    openExternalUrl(props.href);
  };

  return (
    <a {...props} onClick={(e) => handleClick(e)}>
      {props.children}
    </a>
  );
};

export default ExternalLink;
